import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTION_QUERY_KEY } from './useGetMerchandisingCollection';
import { MERCHANDISING_COLLECTIONS_QUERY_KEY } from './useGetMerchandisingCollections';

import MerchandisingCollectionsService, {
  UpdateMerchandisingCollectionDto,
} from '@/services/MerchandisingCollectionsService';

export function useUpdateMerchandisingCollection() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      id,
      dto,
    }: {
      id: number;
      dto: UpdateMerchandisingCollectionDto;
    }) => MerchandisingCollectionsService.updateCollection(id, dto),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTIONS_QUERY_KEY,
      });

      queryClient.invalidateQueries({
        queryKey: [...MERCHANDISING_COLLECTION_QUERY_KEY, variables.id],
      });
    },
  });

  return {
    updateMerchandisingCollection: mutateAsync,
    isLoading: isPending,
  };
}
